<div class="flex h-screen w-full flex-col text-foreground">
  <app-header></app-header>

  <div class="fluid-container w-full py-16">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
